<template>
  <section class="section about">
    <div class="section__container about__container">
      <h2 class="about__title section__title"
          id="about">О компании OFD.ru</h2>
      <p class="about__content">
        <span class="about__ofd">OFD.ru</span> (ООО «ПЕТЕР-СЕРВИС Спецтехнологии») — оператор фискальных данных,
        созданный командой профессионалов в области IT, финансов, телекоммуникаций и расчетных технологий. <br>
        <br>
        Получил разрешение Федеральной налоговой службы на обработку фискальных данных и был включен в реестр ОФД
        в октябре 2016 года. <br>
        В 2018 году OFD.ru был присоединен ФНС России к сети операторов электронного документооборота (ЭДО).<br>
        Помимо юридически значимой передачи фискальных данных и электронных документов, OFD.ru предоставляет
        конвергентные сервисы, - облачные кассы, аналитические продукты и платёжные решения.<br>
        <br>
        Акционером OFD.ru является группа USM Holdings (USM).
      </p>
      <div class="about__action">
        <a href="https://ofd.ru/" target="_blank" class="button button_wide">
          <span>
          Перейти на сайт ofd.ru
          <img src="../../assets/images/chevron.svg" alt="">
          </span>
        </a>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'About'
}
</script>

<style src="./component.scss" scoped lang="scss"/>
